document.addEventListener("DOMContentLoaded", function() {

    // swiper detail - foto nemovitosti (detail-4)
    //============================================
    (function () {
        let swiperSelector = document.querySelector('[data-detail-gallery]');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperDetail = new Swiper(swiperSelector, {
            lazy:  {
                loadPrevNext: true
            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 2,
                },
                2050: {
                    slidesPerView: 3,
                },
                3050: {
                    slidesPerView: 4,
                },
            }
        });
    }());

    initGalleryOnClones();
    function initGalleryOnClones() {
        lightGallery(document.querySelector('[data-detail-gallery] .swiper-wrapper'), {
            selector: '.swiper-slide-duplicate .JS-lightgallery-item'
        });
    }

    const showMapButton = document.querySelector(".JS-show-map");
    if (showMapButton) {
        showMapButton.addEventListener("click", function () {
            const mapDetailElement = document.querySelector(".estateDetail-map");
            if (mapDetailElement) {
                mapDetailElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            } else {
                console.error('Na stránce neexistuje mapa se selectorem ".estateDetail-map". Odstraň tlačítko pro scrollování nebo přidej mapu na stránku.');
            }
            const placeholderShowMapButton = document.querySelector('[data-detail-map-button]');
            if (placeholderShowMapButton) {
                placeholderShowMapButton.dispatchEvent(new MouseEvent('click'));
            }
        })
    }
});